import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAward,FiClock,FiMapPin,FiDollarSign,FiShield,FiThumbsUp}=FiIcons;

const TrustBadges=()=> {
  const badges=[
    {
      icon: FiClock,
      title: '20+ Jahre Erfahrung',
      description: 'Bewährte Expertise im Bauwesen'
    },
    {
      icon: FiAward,
      title: 'Qualitätsbewusst',
      description: 'Höchste Standards und Fachkompetenz'
    },
    {
      icon: FiMapPin,
      title: 'Regionale Partner',
      description: 'Starkes Netzwerk in NRW'
    },
    {
      icon: FiDollarSign,
      title: 'Faire Preise',
      description: 'Transparente Kostenplanung'
    },
    {
      icon: FiShield,
      title: 'Vollversichert',
      description: 'Umfassender Versicherungsschutz'
    },
    {
      icon: FiThumbsUp,
      title: 'Zufriedene Kunden',
      description: 'Persönliche Betreuung'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Warum RUDT Bau?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Vertrauen Sie auf unsere Erfahrung, Qualität und Zuverlässigkeit. Diese Vorteile machen uns zu Ihrem idealen Baupartner.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {badges.map((badge,index)=> (
            <motion.div
              key={badge.title}
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.8,delay: index * 0.1}}
              className="text-center group hover:scale-105 transition-transform duration-300"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-[#3466ad] to-[#2a5291] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:shadow-xl transition-shadow duration-300">
                <SafeIcon icon={badge.icon} className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {badge.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {badge.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;